export const superTokensStyles = `
[data-supertokens~=container] {
   background-color: var(--color-surface-default);
   font-family: var(--font-body);
   box-shadow: none !important;
 }
[data-supertokens~=headerTitle]{
  color: var(--color-text-primary);
  font-family: var(--font-body) !important;

}
[data-supertokens~=divider]{
  display: none !important;
}
[data-supertokens~=partnerLogo]{
  display: inline-block;
  margin-bottom: 1.2rem !important;
}
[data-supertokens~=authHelperText]{
  margin-top: 0.7rem;
  margin-bottom: 1rem !important;
  font-weight: var(--font-weight-normal);
  font-size: var(--text-body-md);
  color: var(--color-text-primary);
  text-transform: none !important;
  font-style: normal !important;

}
[data-supertokens~=inputErrorMessage]{
  color: var(--color-text-error);
}
[data-supertokens~=label]{
 color: var(--color-text-primary);
 font-family: var(--font-body) !important;
}
[data-supertokens~=superTokensBranding]{
  display: none
}
[data-supertokens="headerSubtitle secondaryText"]{
  color: var(--color-text-primary) !important;
  margin-bottom: 0px;
}
[data-supertokens="primaryText enterEmailSuccessMessage"]{
  color: var(--color-text-primary) !important;
}
[data-supertokens="container resetPasswordEmailForm"]{
  [data-supertokens="headerTitle"]{
    color: var(--color-text-primary) !important;
  }
  [data-supertokens="headerSubtitle secondaryText"]{
    color: var(--color-text-primary) !important;
    margin-bottom: 15px;
  }
}
[data-supertokens="container resetPasswordPasswordForm"]{
  [data-supertokens="headerTitle"]{
    color: var(--color-text-primary) !important;
  }
  [data-supertokens="headerSubtitle secondaryText"]{
    color: var(--color-text-primary) !important;
    margin-bottom: 15px;
  }
}
[data-supertokens="backButton backButtonCommon"] svg path {
  fill: var(--color-text-primary) !important;
}
[data-supertokens="secondaryText secondaryLinkWithLeftArrow"]{
  color: var(--color-text-primary) !important;
}
[data-supertokens="primaryText submitNewPasswordSuccessMessage"]{
  color: var(--color-text-primary) !important;
}
[data-supertokens~=button] {
  font-family: var(--font-body) !important;
  background-color: var(--auth-button-background-default);
  border-radius: var(--radius-6xl);
  color: var(--auth-button-text-color-default);
  margin: 0 auto;
  border: 0;
}
[data-supertokens~="button"]:focus-visible {
  outline: 2px solid var(--auth-button-focus-color-default); /* fallback blue */
  outline-offset: 2px;
}

[data-supertokens~="button"]:hover {
  background-color: var(--auth-button-background-hover);
  color: var(--auth-button-text-color-hover);
  outline: 1px solid var(--auth-button-focus-color-default); /* fallback blue */
  outline-offset: 2px;
}

 [data-supertokens~=sectionHeader] {
  font-size: var(--text-body-xl);
  font-weight: var(--font-weight-h6);
  text-align: start;
  margin: 14px 0
}
[data-supertokens~=conditionContainer] {
  display: flex;
  align-items: center;
  gap: 1rem;
}
[data-supertokens~=infoConditionContainer] {
  display: flex;
  align-items: center;
  gap: 1rem;
  text-align: left;
}
[data-supertokens~=conditionText] {
 font-size: var(--text-body-sm);
 font-weight: var(--font-weight-h6);
 text-align: left;
}
[data-supertokens~=link] {
 font-size: var(--text-body-sm);
 font-weight: var(--font-weight-h6);
 color: var(--color-text-info);
 font-family: var(--font-body) !important;
}
[data-supertokens~='conditionCheckbox'] {
 -webkit-appearance: none !important;
 appearance: none !important;
 width: 16px !important;
 height: 16px !important;
 border: 1px solid var(--color-border-neutral-softer-3) !important;
 background-color: white !important;
 position: relative !important;
 cursor: pointer !important;
 accent-color: unset !important;
 padding: 0 !important;
 box-sizing: border-box !important;
}
[data-supertokens~='conditionCheckbox']:checked::before {
 content: '\\2713';
 color: black;
 font-size: var(--text-size-5);
 position: absolute;
 top: -2px;
 left: 0px;
 line-height: 1;
 font-weight: var(--font-weight-h1);
}
[data-supertokens~=inputWrapper ] {
   height: 2.5625rem;
}
[data-supertokens~=input] {
  display: flex;
  align-items: center;
  background-color: var(--color-surface-default);
  color: var(--color-text-primary);
  paddingTop: 20px;
}
[data-supertokens~=dropDownTrigger] {
  box-sizing: border-box;
  background-color: var(--color-surface-default);
  border: 1px solid var(--color-border-neutral-softer-3);
  padding: var(--vertical-spacing-2-5) var(--horizontal-spacing-2);
  color: var(--color-text-primary);
  letter-spacing: 1.2px;
  flex: 9 1 75%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
[data-supertokens~=row] {
  width: 88%;
  padding-top: 0;
}
[data-supertokens~=countryInputContainer] {
 margin-top: -12px;
}
  @media (max-width: 440px) {
    [data-supertokens~="container"] {
      width: 90vw;
    }
  }
`;
